<div class="b-dropdown--text" [innerHTML]="text"></div>
<div class="b-dropdown--list" [class.b-contains-selected]="containsSelected()">
    <div [ngClass]="{'b-dropdown--list-item': true, 'b-selected': i===activeIndex, 'b-is-selected' : isSelected(item)}"
        *ngFor="let item of list; let i = index;" [innerHTML]="label(item)"
        [style.opacity]="isDisabled(item) ? '0.5' : ''" 
        (click)="wDropdownClick.emit(item)"
        [attr.title]="getTitle(item)" 
        ></div>
</div>